var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center secondary py-5 w-100"},[_c('div',{staticClass:"textOverSecondary--text",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.openLegal()}}},[_vm._v("\n    "+_vm._s(_vm.$t("modals.sign_up.legal"))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }